export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjc3OWQ2NTE0LTM2MjUtNGY3Zi1iOGVkLWQzYWM3NDFlYWFiYSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.mJw5J2vFbDW8rZ7DnwZbGtweKJwqt8n3bdHxEXsBRZCSUDmBCqCIozmcHuUZcaZc3OfZOA7dB09/NCgGtClNi0OkuZgJv0cOLvHrbwaAjUvIHV89Amx+SA81Z6KJGQWuSzD8aQ=='
